webpackJsonp([29],{

/***/ 1051:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function mounted() {
	var _this = this;

	setTimeout(function () {
		_this.loadHelpInformation();
	}, 200);
}

function loadHelpInformation() {
	var _$route$params = this.$route.params,
	    help = _$route$params.help,
	    slug = _$route$params.slug;

	if (this.getCommerceData && this.getCommerceData.helperCenter) {
		var helperCenter = this.getCommerceData.helperCenter;

		this.helpData = this.findCurrentHelpSection(helperCenter, help, slug);
	} else {
		this.$router.push({ name: 'not-found' });
	}
}

function findCurrentHelpSection(helper, section, subSection) {
	var sectionFormatted = this.formattedString(section);
	var subSectionFormatted = this.formattedString(subSection);
	var filteredHelpCenter = helper.filter(function (h) {
		return h.section[0].name.trim() === sectionFormatted.trim();
	});
	return this.constructingHelpObject(filteredHelpCenter, sectionFormatted, subSectionFormatted);
}

function constructingHelpObject(helpArray, sectionTitle, subSectionTitle) {
	return helpArray.reduce(function (acc, item) {
		var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, acc);
		if (!obj.title) {
			obj.title = sectionTitle;
		}
		if (item.name === subSectionTitle) {
			obj.section = {
				title: item.name,
				subTitle: item.subTitle,
				content: item.description,
				image: item.urlImage
			};
		}
		var help = sectionTitle.split(' ').join('-');
		var slug = item.name.split(' ').join('-');
		obj.subTitles.push({ title: item.name, route: '/ayuda/apartado/' + help + '/seccion/' + slug });
		return obj;
	}, { title: '', section: {}, subTitles: [] });
}

function formattedString(str) {
	return str.split('-').join(' ');
}

function routeHandler() {
	this.loadHelpInformation();
}

function title() {
	return this.helpData.section.title || '';
}

function subtitle() {
	return this.helpData.section.subTitle || '';
}

function content() {
	var html = this.helpData.section.content.includes('</');
	this.isHtml = !!html;
	return this.helpData.section.content;
}

function image() {
	return this.helpData.section.image || '';
}

function data() {
	return {
		isHtml: false,
		helpData: {
			title: '',
			section: {
				title: '',
				subTitle: '',
				content: '',
				image: ''
			},
			subTitles: [{ title: '', route: '' }]
		},
		open: false,
		show: true
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'help-base',
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getCommerceData']), {
		content: content,
		image: image,
		subtitle: subtitle,
		title: title
	}),
	data: data,
	methods: {
		constructingHelpObject: constructingHelpObject,
		findCurrentHelpSection: findCurrentHelpSection,
		formattedString: formattedString,
		loadHelpInformation: loadHelpInformation,
		routeHandler: routeHandler
	},
	mounted: mounted,
	watch: {
		'$route.fullPath': routeHandler
	}
});

/***/ }),

/***/ 1276:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1277);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(778)("b4e5eba2", content, true, {});

/***/ }),

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(777)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Avenir Next Regular;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi\"),url(\"/static/fonts/AvenirNextLTPro-Demi.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Bold;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Book;font-style:normal;font-weight:400;src:local(\"Avenir Next Book\",url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))}.help-main-container[data-v-4a21e3b2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin:auto;max-width:1090px;width:100%}@media(min-width:768px){.help-main-container[data-v-4a21e3b2]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}.help-main-container .help-menu[data-v-4a21e3b2]{background-color:#fff;border-radius:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;margin:0 0 20px;padding:21px;position:sticky;top:80px}@media(min-width:768px){.help-main-container .help-menu[data-v-4a21e3b2]{margin-right:20px;top:140px}}.help-main-container .help-menu .title-btn-container[data-v-4a21e3b2]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.help-main-container .help-menu .title-btn-container .title-btn[data-v-4a21e3b2]{font-family:Avenir Next Bold;font-size:16px;margin-bottom:5px;text-align:left}.help-main-container .help-menu .title-btn-container .down[data-v-4a21e3b2],.help-main-container .help-menu .title-btn-container .up[data-v-4a21e3b2]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;margin-right:10px;-webkit-transform:rotate(0deg);transform:rotate(0deg);-webkit-transition:-webkit-transform .25s ease;transition:-webkit-transform .25s ease;transition:transform .25s ease;transition:transform .25s ease,-webkit-transform .25s ease;-webkit-transform-origin:center 7px;transform-origin:center 7px}@media(min-width:768px){.help-main-container .help-menu .title-btn-container .down[data-v-4a21e3b2],.help-main-container .help-menu .title-btn-container .up[data-v-4a21e3b2]{display:none}}.help-main-container .help-menu .title-btn-container .down[data-v-4a21e3b2]{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.help-main-container .help-menu .help-menu-routes[data-v-4a21e3b2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.help-main-container .help-menu .sub-title[data-v-4a21e3b2]{margin:10px 0;text-decoration:none}.help-main-container .help-menu .sub-title.router-link-exact-active[data-v-4a21e3b2]{text-decoration:underline}.help-main-container .help-content[data-v-4a21e3b2]{border-radius:5px;padding:35px 20px 60px;width:auto}@media(min-width:768px){.help-main-container .help-content[data-v-4a21e3b2]{padding:35px 60px 60px;width:800px}}", "", {"version":3,"sources":["/opt/build/repo/src/components/help/help-base.vue"],"names":[],"mappings":"AACA,WAAW,gCAAkC,kBAAkB,gBAAmB,wGAAwG,CACzL,AACD,WAAW,+BAAiC,kBAAkB,gBAAmB,kGAAkG,CAClL,AACD,WAAW,oCAAsC,kBAAkB,gBAAmB,0GAA0G,CAC/L,AACD,WAAW,2CAA6C,kBAAkB,gBAAmB,mHAAmH,CAC/M,AACD,WAAW,+BAAiC,kBAAkB,gBAAmB,kHAAkH,CAClM,AACD,WAAW,sCAAwC,kBAAkB,gBAAmB,+GAA+G,CACtM,AACD,WAAW,6BAA+B,kBAAkB,gBAAmB,kGAAkG,CAChL,AACD,WAAW,oCAAsC,kBAAkB,gBAAmB,2GAA2G,CAChM,AACD,WAAW,6BAA+B,kBAAkB,gBAAmB,kGAAkG,CAChL,AACD,WAAW,8BAAgC,kBAAkB,gBAAmB,mGAAmG,CAClL,AACD,WAAW,qCAAuC,kBAAkB,gBAAmB,6GAA6G,CACnM,AACD,WAAW,6BAA+B,kBAAkB,gBAAmB,kFAAmF,CACjK,AACD,sCAAsC,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,uBAAuB,oBAAoB,2BAA2B,YAAY,iBAAiB,UAAU,CAChT,AACD,wBACA,sCAAsC,8BAA8B,6BAA6B,uBAAuB,mBAAmB,wBAAwB,qBAAqB,sBAAsB,CAC7M,CACA,AACD,iDAAiD,sBAAsB,kBAAkB,oBAAoB,oBAAoB,aAAa,mBAAmB,iBAAiB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,2BAA2B,wBAAwB,mBAAmB,gBAAkB,aAAa,gBAAgB,QAAQ,CACpa,AACD,wBACA,iDAAiD,kBAAkB,SAAS,CAC3E,CACA,AACD,sEAAsE,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,6BAA6B,CACxQ,AACD,iFAAiF,6BAA+B,eAAe,kBAAkB,eAAe,CAC/J,AACD,sJAAsJ,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,kBAAkB,+BAA+B,uBAAuB,+CAAgD,uCAAwC,+BAAgC,2DAA8D,oCAAoC,2BAA2B,CACzkB,AACD,wBACA,sJAAsJ,YAAY,CACjK,CACA,AACD,4EAA4E,iCAAiC,wBAAwB,CACpI,AACD,mEAAmE,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,qBAAqB,CAC/N,AACD,4DAA4D,cAAc,oBAAoB,CAC7F,AACD,qFAAqF,yBAAyB,CAC7G,AACD,oDAAoD,kBAAkB,uBAAuB,UAAU,CACtG,AACD,wBACA,oDAAoD,uBAAuB,WAAW,CACrF,CACA","file":"help-base.vue","sourcesContent":["\n@font-face{font-family:\"Avenir Next Regular\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Ultra Light\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Ultra Light Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Medium\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Medium Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Demi\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Demi\"),url(\"/static/fonts/AvenirNextLTPro-Demi.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Demi Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Bold\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Heavy\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Heavy Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Book\";font-style:normal;font-weight:normal;src:local(\"Avenir Next Book\", url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))\n}\n.help-main-container[data-v-4a21e3b2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin:auto;max-width:1090px;width:100%\n}\n@media(min-width: 768px){\n.help-main-container[data-v-4a21e3b2]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n}\n.help-main-container .help-menu[data-v-4a21e3b2]{background-color:#fff;border-radius:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;margin:0 0 20px 0;padding:21px;position:sticky;top:80px\n}\n@media(min-width: 768px){\n.help-main-container .help-menu[data-v-4a21e3b2]{margin-right:20px;top:140px\n}\n}\n.help-main-container .help-menu .title-btn-container[data-v-4a21e3b2]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between\n}\n.help-main-container .help-menu .title-btn-container .title-btn[data-v-4a21e3b2]{font-family:\"Avenir Next Bold\";font-size:16px;margin-bottom:5px;text-align:left\n}\n.help-main-container .help-menu .title-btn-container .up[data-v-4a21e3b2],.help-main-container .help-menu .title-btn-container .down[data-v-4a21e3b2]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;margin-right:10px;-webkit-transform:rotate(0deg);transform:rotate(0deg);-webkit-transition:-webkit-transform 250ms ease;transition:-webkit-transform 250ms ease;transition:transform 250ms ease;transition:transform 250ms ease, -webkit-transform 250ms ease;-webkit-transform-origin:center 7px;transform-origin:center 7px\n}\n@media(min-width: 768px){\n.help-main-container .help-menu .title-btn-container .up[data-v-4a21e3b2],.help-main-container .help-menu .title-btn-container .down[data-v-4a21e3b2]{display:none\n}\n}\n.help-main-container .help-menu .title-btn-container .down[data-v-4a21e3b2]{-webkit-transform:rotate(180deg);transform:rotate(180deg)\n}\n.help-main-container .help-menu .help-menu-routes[data-v-4a21e3b2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.help-main-container .help-menu .sub-title[data-v-4a21e3b2]{margin:10px 0;text-decoration:none\n}\n.help-main-container .help-menu .sub-title.router-link-exact-active[data-v-4a21e3b2]{text-decoration:underline\n}\n.help-main-container .help-content[data-v-4a21e3b2]{border-radius:5px;padding:35px 20px 60px;width:auto\n}\n@media(min-width: 768px){\n.help-main-container .help-content[data-v-4a21e3b2]{padding:35px 60px 60px;width:800px\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-main-container"},[_c('div',{staticClass:"help-menu",style:(("border:1px solid " + (_vm.globalColors.base)))},[_c('button',{staticClass:"title-btn-container",style:(("border-bottom:1px solid " + (_vm.globalColors.base) + ";color:" + (_vm.globalColors.primary))),on:{"click":function($event){_vm.show = !_vm.show}}},[_c('h2',{staticClass:"title-btn",attrs:{"type":"button"}},[_vm._v(_vm._s(_vm.helpData.title))]),_vm._v(" "),_c('div',{class:[_vm.show ? 'up' : 'down']},[_vm._v("^")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"help-menu-routes"},_vm._l((_vm.helpData.subTitles),function(sub,indexSub){return _c('router-link',{key:indexSub,staticClass:"sub-title",style:(("color:" + (_vm.globalColors.title))),attrs:{"to":sub.route}},[_vm._v(_vm._s(sub.title))])}),1)]),_vm._v(" "),_c('div',{staticClass:"help-content",style:(("border:1px solid " + (_vm.globalColors.base)))},[_c('router-view',{attrs:{"is-html":_vm.isHtml,"title":_vm.title,"sub-title":_vm.subtitle,"content":_vm.content,"image":_vm.image}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_base_vue__ = __webpack_require__(1051);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a21e3b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_base_vue__ = __webpack_require__(1278);
function injectStyle (ssrContext) {
  __webpack_require__(1276)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a21e3b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_base_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a21e3b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_base_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/29.6630bd7ff8f3d1d34d3c.js